import { Button, Container, Stack } from "react-bootstrap";
import Header from "../../shared/components/Header";
import Layout from "../../shared/components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import PlanListBlock from "../component/PlanListBlock";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPlans, resetError } from "../store/plansSlice";
import { toast, ToastContainer } from "react-toastify";
import { logout } from "../../auth/store/authSlice";

const ChangePlanPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { accessToken } = useSelector((state) => state.auth);
  const currentTenant = useSelector((state) => state?.sharedSlice?.currentTenant)
  const { currentPlanError, currentPlanErrorMessage } = useSelector((state) => state.plans);


  useEffect(() => {
    if (currentPlanError) {
      dispatch(resetError())
      if (currentPlanErrorMessage == "Token is invalid or expired") {
        toast.error("Your session has expired. Please login again.")
        dispatch(logout())
        navigate("/login")
      } else {
        toast.error("Unable to fetch plans . Please try again later.");
      }

    }
  }, [currentPlanError])


  useEffect(() => {
    dispatch(
      fetchPlans({
        access_token: accessToken,
        flavor: currentTenant?.flavor,
        tenant_id: currentTenant?.id
      })
    );
  }, [location]);

  return (
    <Layout>
      <ToastContainer />
      <Header
        title="Manage Plan"
        ItemActions={
          <Stack>
            <Button
              variant="outline-secondary"
              onClick={() => {
                navigate("/plan/billing");
              }}
            >
              Back
            </Button>
          </Stack>
        }
      />
      <Container
        fluid
        className=" py-2 "
        style={{
          height: "calc(100vh - 60px)",
          overflowy: "scroll",
          overflowX: "hidden",
        }}
      >
        <PlanListBlock />
      </Container>
    </Layout>
  );
};

export default ChangePlanPage;
